import type { IStorePackage } from '../stores/app/types';

import { getRequest } from './api';
import type { ApiResponse } from './types';

export async function getExtendedOffer(key: string): Promise<IStorePackage[]> {
  const resp = await getRequest<ApiResponse<{ packages: IStorePackage[] }>>('user/store/extended-offer', { key });
  return resp.data.data.packages;
}

export default getExtendedOffer;
